export function isMobileViewport() {
  if (typeof window === "undefined") return false;
  const agent = navigator.userAgent || navigator.vendor || "";
  const mobile = /android|iPad|iPhone|iPod/i.test(agent) || (/Macintosh/i.test(agent) && navigator.maxTouchPoints > 1);
  const width = window.innerWidth || document.documentElement.clientWidth;
  return mobile || (width > 0 && width <= 768);
}

export function watchDeviceViewport(onChange) {
  const update = () => onChange(isMobileViewport());
  update();
  const events = ["resize", "orientationchange", "pageshow", "focus"];
  events.forEach((event) => window.addEventListener(event, update));
  document.addEventListener("visibilitychange", update);
  window.visualViewport?.addEventListener("resize", update);
  return () => {
    events.forEach((event) => window.removeEventListener(event, update));
    document.removeEventListener("visibilitychange", update);
    window.visualViewport?.removeEventListener("resize", update);
  };
}
